import { render, staticRenderFns } from "./downpay.vue?vue&type=template&id=121e6898&scoped=true&"
import script from "./downpay.vue?vue&type=script&lang=js&"
export * from "./downpay.vue?vue&type=script&lang=js&"
import style0 from "./downpay.vue?vue&type=style&index=0&id=121e6898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e6898",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDialog,VFlex,VImg,VLayout})
